import { InvalidUrlError } from '../../errors/errors';
import { BaseGQLService } from '../../services/BaseGQLService';
import { FilterOperator } from '../../types/gql-types';
import { CursorInfo, PaginationResult } from '../../types/pagination';
import { ModelType } from '../../utils/GQLIdEncoder';
import { LocationMapper } from '../mappers/LocationMapper';
import { Location } from '../models/Location';

export enum LocationVariant {
  Key = 'Key',
  Certificate = 'Certificate',
  Instance = 'Instance',
}

export const LOCATIONS_FRAGMENT = `
pageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
edges {
  node {
    id
    hostname
    path
    fileType
    imageInfo
    imageType
  }
}
totalCount
`;

export const GET_LOCATIONS_QUERY = (variant: LocationVariant) => {
  return `
query ($id: ID!, $first: Int, $last: Int, $after: String, $before: String) {
  node(id: $id) {
    ... on ${variant} {
      locations(first: $first, after: $after, last: $last, before: $before) {
        ${LOCATIONS_FRAGMENT}
      }
    }
  }
}
`;
};

export class LocationsService extends BaseGQLService {
  private readonly mapper = new LocationMapper();

  async getLocations(variantId: number, variant: LocationVariant, cursor: CursorInfo, filters: FilterOperator | null): Promise<PaginationResult<Location>> {
    return this.query(
      GET_LOCATIONS_QUERY(variant),
      {
        id: this.gqlIdEncoder.encode(ModelType[variant], variantId),
        ...this.mapCursorInfo(cursor),
        filters,
      },
      (data) => {
        if (!data.node) {
          throw new InvalidUrlError(`Invalid request: could not find ${variant} ${variantId}`);
        }
        const { edges: locations, pageInfo, totalCount } = data.node.locations;
        return {
          data: locations.map((location: any) => this.mapper.mapGQLModel(location.node)),
          pageInfo,
          totalCount,
        };
      }
    );
  }
}
